import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([
  {
    margin: '0 auto',
    maxWidth: '744px',
    width: '100%'
  }
]);

const DisplayMaxWidthMedium = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-max-width-medium');
  
  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} />;
}
export default DisplayMaxWidthMedium;